import { gql } from "@apollo/client";

export const CREATE_PROCUREMENT = gql`
  mutation createProcurementRequest($procurementRequest: ProcurementRequestInput!) {
    createProcurementRequest(procurementRequest: $procurementRequest) {
      id
      status
      items {
        id
        requestId
        assetType
        quantity
        make
        model
        variant
        fuel
        transmission
        condition
        expectedByDate
        status
        note {
          description
          createdBy {
            id
            firstName
            lastName
          }
          createdAt
        }
      }
    }
  }
`;